import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = ({ measurementId }) => {
  const location = useLocation();

  // Efecto para cargar el script de Google Analytics
  useEffect(() => {
    const loadGoogleAnalytics = () => {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.async = true;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());

      // Configuración inicial con título de página
      gtag('config', measurementId, {
        page_path: location.pathname + location.search,
        page_title: document.title
      });
    };

    loadGoogleAnalytics();
    // Función de limpieza
    return () => {
      const script = document.querySelector(`script[src*="${measurementId}"]`);
      if (script) {
        script.remove();
      }
    };
  }, [measurementId, location.pathname, location.search]); // Incluimos todas las dependencias

  // Efecto para manejar cambios de página y título
  useEffect(() => {
    // Función para obtener un título descriptivo basado en la ruta
    const getPageTitle = () => {
      // Eliminar barras y convertir a título legible
      const pathName = location.pathname.replace(/^\/?|\/?$/g, ''); // Elimina barras al inicio y final
      if (!pathName) return 'Presupuesto Participativo';

      return pathName
        .split('/')
        .map(segment => 
          segment
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
        )
        .join(' - ');
    };

    // Actualizar el título del documento
    const pageTitle = getPageTitle();
    document.title = pageTitle;

    // Trackear cambios de página con el título actualizado
    if (window.gtag) {
      window.gtag('config', measurementId, {
        page_path: location.pathname + location.search,
        page_title: pageTitle,
        page_location: window.location.href
      });

      // Enviar un evento personalizado para mejor tracking
      window.gtag('event', 'page_view', {
        page_title: pageTitle,
        page_path: location.pathname + location.search,
        page_location: window.location.href
      });
    }
  }, [location, measurementId, location.pathname, location.search]); // Incluimos todas las dependencias

  return null;
};

export default GoogleAnalytics;